export default __webpack_public_path__ + "static/media/faci05.0b93981e.jpg";